import React, { ButtonHTMLAttributes, ReactNode } from 'react'
import { SVGIconName } from '../../../svgIcons'
import { getSite } from '@shared/Frontend/utils/site'
import { Link, LinkProps } from './link'
import { strictOmit, StrictOmit } from './strictOmit'
import { SVGIcon } from './svg'

const site = getSite()

export type ClickableProps = (ClickableButtonProps | ClickableLinkProps) & ClickableInnerProps
type ClickableLinkProps = { elementKind: 'link'; disabled?: boolean } & StrictOmit<LinkProps, 'children'>
type ClickableButtonProps = { elementKind: 'button' } & StrictOmit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'>
// Returns a <button> or <a>, with button- or link-styling
export const Clickable = ({
  label,
  styleKind,
  icon,
  hasBlob,
  disabled,
  iconOnly,
  ...props
}: ClickableProps & { styleKind: 'link' | 'button' }) =>
  props.elementKind == 'button' ? (
    <button
      {...strictOmit('elementKind', props)}
      disabled={disabled || false}
      title={iconOnly && typeof label == 'string' ? label : undefined}
    >
      <ClickableInner label={label} styleKind={styleKind} icon={icon} hasBlob={hasBlob} iconOnly={iconOnly} />
    </button>
  ) : (
    <Link
      {...strictOmit('elementKind', props)}
      aria-disabled={disabled}
      title={iconOnly && typeof label == 'string' ? label : undefined}
    >
      <ClickableInner label={label} styleKind={styleKind} icon={icon} hasBlob={hasBlob} iconOnly={iconOnly} />
    </Link>
  )

type ClickableInnerProps = { label: ReactNode; icon?: SVGIconName; iconOnly?: boolean; hasBlob?: boolean }
const ClickableInner = ({
  label,
  icon,
  styleKind,
  iconOnly,
  hasBlob
}: ClickableInnerProps & { styleKind: 'link' | 'button' }) => {
  const innerClass = 'clickable__inner';
  const iconClass = 'clickable__icon';
  const labelClass = 'clickable__label';
  // const iconClass = styleKind === 'link' ? 'link__icon' : 'button__icon';
  // const labelClass = styleKind === 'link' ? 'link__label' : 'button__label';
  return (
    <span className={`${innerClass}`}>
      {icon && (
        <>
          {site == 'ZEG' ? (
            <SVGIcon id={icon} className={`${iconClass} ${iconClass}--first`} size={20} />
          ) : (
            <SVGIcon id={icon} className={`${iconClass} ${iconClass}--first`} size={16} />
          )}
        </>
      )}
      {hasBlob == true && (
        <>
          {site == 'ZEG' ? (
            <>
              <SVGIcon id={'icon-circle-hollow'} className={`${iconClass} ${iconClass}--blob-hollow`} width={32} height={32} />
              <SVGIcon id={'icon-circle'} className={`${iconClass} ${iconClass}--blob-filled`} width={32} height={32} />
            </>
          ) : (
            <>
              <SVGIcon id={'icon-blob-hollow'} className={`${iconClass} ${iconClass}--blob-hollow`} width={29} height={24} />
              <SVGIcon id={'icon-blob'} className={`${iconClass} ${iconClass}--blob-filled`} width={29} height={24} />
            </>
          )}
        </>
      )}
      <span className={iconOnly ? 'sr-text' : labelClass}>{label}</span>
    </span>
  )
}
